<template>
    <div class="exemption-edit layout-max-width">

        <b-alert show variant="danger"
                 v-if="exemptionClosed">
            <b-row>
                <b-col cols="8" class="pt-1">
                    This Exemption Request can no longer be edited.
                </b-col>
                <b-col cols="4" class="text-right">
                    <strong>Status:</strong>
                    <exemption-status-badge :status="exemption.status"/>
                </b-col>
            </b-row>
        </b-alert>

        <data-form :title="`Edit Exemption Request${vehicleId ? (': ' + vehicleId) : ''}`"
                   tag="exemption-edit-title"
                   :field-model="exemptionFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :save-button-disabled="exemptionClosed"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="successRoute"
                   submit-error-message="Error updating Exemption Request"/>

        <attachment-list class="mt-2"
                         model-class="Exemption"
                         model-table="exemption"
                         help-tag="exemption-upload"
                         :model-id="exemptionId"
                         :readOnly="false"/>

        <h3 class="mt-5">Activity Log</h3>

        <log-entries table="exemption" :model-instance-id="exemptionId"/>

    </div>
</template>

<script>

import Vue from 'vue'
import ExemptionFields from '@/models/Exemption'

/**
 * Page for equipment owner (not admin) to edit exemption
 * Admin approves/denies exemption via ExemptionView
 */
export default Vue.extend({
    name: 'ExemptionEdit',
    props: {
        exemptionId: Number,
    },
    data () {
        const isAdmin = this.$user.isAdmin() || this.$user.isSuperAdmin()

        return {
            exemption: null,
            equipment: null,
            vehicleId: '',
            exemptionFields: ExemptionFields,

            fieldGroups: [
                [
                    'ownerStatus',
                    'type',
                    'project_id',
                    'notes',
                ]
            ],
        }
    },
    computed: {
        equipmentId () {
            return this.equipment ? this.equipment.id : null
        },
        companyId () {
            return this.equipment ? this.equipment.company_id : null
        },
        successRoute () {
            return `/equipment/view/${this.equipmentId}`
        },
        exemptionClosed () {
            return this.exemption && (this.exemption.status === 'APPROVED' || this.exemption.status === 'DENIED')
        }
    },
    methods: {
        async loadModelInstance () {
            const item = await this.$api.getItem(this, 'exemption', this.exemptionId, ['equipment', 'userLogs'])
            this.exemption = item
            this.equipment = item.equipment
            this.vehicleId = item.equipment.vehicle_id
            return item
        },
        async onSubmit (modelInstance, isValid) {
            // NB: no successRoute is specified on the form, so we can show a message here and then redirect
            this.$api.updateItem(this, 'exemption', modelInstance)
            const message = modelInstance.status === 'DRAFT' ?
                `Select OK to save this Exemption Request as a draft. To submit it for approval,
                select Cancel and change the Status of Request at the top of the form to Submitted.`
                :
                `Select OK to submit this Exemption Request for approval.
                To save it as a draft, select Cancel and change the Status of Request at the top
                of the form to Draft.`
            const ok = await this.$bvModal.msgBoxConfirm(message)
            if (ok) {
                this.$router.push(`/equipment/view/${this.equipmentId}`)
            }
        },
    },
})

</script>
<style lang="scss">
.exemption-edit {
    fieldset {
        small {
            font-size: 1.05em;
            color: var(--medium-blue) !important;
            border-top: solid 1px #ccc;
            margin-top: .5em;
            padding: 1em;
        }
    }
}
</style>